module.exports = require("@projectstorm/react-canvas-core");